export const STEP_FIVE_STAGE = {
  INPUT_ANSWER: 'INPUT_ANSWER',
  RESULT: 'RESULT',
  REPORT: 'REPORT',
} as const

export type StepFiveStageType = keyof typeof STEP_FIVE_STAGE

export const SPREAD_SCORE_INFO_REQUEST_INPUT_SCORE_RANGES = [
  {
    from: 0,
    to: 6,
  },
  {
    from: 7,
    to: 12,
  },
  {
    from: 13,
    to: 18,
  },
  {
    from: 19,
    to: 24,
  },
  {
    from: 25,
    to: 30,
  },
  {
    from: 31,
    to: 36,
  },
  {
    from: 37,
  },
]
